var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 151,
    viewBox: "0 0 251 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M125.5 150.013C194.812 150.013 251 148.081 251 145.697C251 143.314 194.812 141.382 125.5 141.382C56.1882 141.382 0 143.314 0 145.697C0 148.081 56.1882 150.013 125.5 150.013Z",
    fill: "#6C63FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M180.136 43.5052C174.958 18.6932 152.764 0 125.764 0C104.31 0 85.8152 11.8657 76.5661 29.1204C54.3725 31.2781 36.9893 49.617 36.9893 71.9239C36.9893 95.6553 56.9599 115.078 81.3765 115.078H177.549C197.891 115.078 214.538 98.8936 214.538 79.1163C214.577 70.0288 211.033 61.2724 204.634 54.6483C198.234 48.0243 189.468 44.0365 180.136 43.5052V43.5052ZM137.597 64.714V92.0451H113.924V64.714H88.7708L125.76 28.7696L162.75 64.7315L137.597 64.714Z",
    fill: "#6C63FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.b50e798a32e98af1f9fc989f30e3c4bb.svg";
export { ForwardRef as ReactComponent };